/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useEffect, useState } from "react";
import useCompanyName from "../../hooks/useCompanyName";
import { useIsCompanyAuthorirzedQuery } from "../../services/authService"
import { useGetAccountsQuery, useGetDashValuesQuery, useGetSyncCountsQuery, useGetTaxesQuery } from "../../services/dashboardService";
import { useDispatch, useSelector } from 'react-redux';
import useJeAsCategory from "../../hooks/useJeAsCategory";
import { setIsTaxAgency, setShowLayAway } from "../../redux/reducer/globalsReducer";
import amIVisible from "../../componentControl/registry";
import { PageLayout } from "../pageLayout/PageLayout";
import { Form, Formik } from 'formik';
import { getValidationSchema } from "../../utils/helpers/fieldsValidation";
import { useTranslation } from 'react-i18next';
import { getCleanState } from "../../utils/helpers/dashboard";
import { dashboardTransformer } from '../../utils/helpers/dashboardTransformer';
import { MapAccounts } from "./MapAccounts";
import { CogsInventorySection } from "../cogsInventory/CogsInventorySection";
import { OptionsSection } from './OptionsSection';
import useAppConnected from "../../hooks/useAppConnected";
import { SyncLogs } from '../syncLogs/SyncLogs';
import { IndividualPaymentMapping } from "../mapPaymentMethods/IndividualPaymentMapping";
import { IndividualProductMapping } from '../mapSales/IndividualProductMapping';
import { IndividualCategoriesMapping } from '../mapSales/IndividualCategoryMapping';
import { setRefetchSyncCount, setRefreshAccounts, setCurrentComponent } from "../../slices/dashboardSlice";
import { setIsReconnecting } from "../../slices/authSlice";
import { IndividualPoProductMapping } from "../cogsInventory/individualPo/IndividualProductPo";
import { IndividualPoCategoriesMapping } from "../cogsInventory/individualPo/IndividualCategoriesPo";
import { useLocationData } from "../../hooks/useLocation";
import Logout from "../custom/logout";
import InfoDashboard from "./InfoDashboard";
import "./dash.css"
import { Divider } from "antd";
import { IndividualDiscountMapping } from '../mapDiscounts/IndividualDiscountMapping';
import { SessionTimeoutError } from "./dashComponents/sessionTimeout";
import { resetSyncPage } from "../../slices/syncSlice";
import { IndividualProductIDsMapping } from "../mapSales/IndividualProductLevelMapping";
import { IndividualPoProductLevelMapping } from "../cogsInventory/individualPo/IndividualProductLevelPo";
import { IndividualServiceProductMapping } from "../mapServices/IndividualServiceProductMapping";
import { IndividualServiceCategoryMapping } from "../mapServices/IndividualServiceCategoryMapping";
import { useNavigate, useLocation } from "react-router-dom";

export const Dashboard = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const routeProps = { navigate, location, path: location.pathname };

    const key = useRef(Date.now()).current;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [companyName, setCompanyName] = useCompanyName();
    const [, setConnected] = useAppConnected();

    const { isMultiLocation, currentLocation } = useLocationData()

    const [, setJeAsCategory] = useJeAsCategory();
    const [initialValues] = useState(getCleanState(true));
    const configData = useSelector(state => state.dashboard.fetchedConfig)

    const { currentComponent, currentPostingMethod, isAccountLoading, isRefreshAccount, refreshAccounts, refetchSyncCount,  } = useSelector(state => state.dashboard)

    const { connectionMode } = useSelector(state => state.auth)

    // isCompanyAuthorize
    const isCompanyAuthorizeResponse = useIsCompanyAuthorirzedQuery({ key }, { refetchOnMountOrArgChange: 1 })

    // fetch all configurations
    const configurationResponse = useGetDashValuesQuery({ key }, {
        refetchOnMountOrArgChange: true,
        skip: !isCompanyAuthorizeResponse.isSuccess,
        selectFromResult: ({ data, ...rest }) => {
            return {
                initialData: { ...data, ...data?.attributes },
                data: dashboardTransformer({ ...data, ...data?.attributes }),
                ...rest
            }
        }
    })

    // fetch all accounts and taxes
    const accountsData = useGetAccountsQuery({ key, isRefresh: isRefreshAccount, journalEntry: currentPostingMethod === 'journalEntry' }, { skip: !configurationResponse?.isSuccess, refetchOnMountOrArgChange: false })
    const taxData = useGetTaxesQuery({ key, journalEntry: currentPostingMethod === 'journalEntry' }, { skip: !configurationResponse?.isSuccess, refetchOnMountOrArgChange: false })

    const syncCounts = useGetSyncCountsQuery({ key }, { skip: !configurationResponse?.isSuccess, refetchOnMountOrArgChange: false })

    useEffect(() => {
        if (isAccountLoading && !accountsData.isLoading) {
            try {
                accountsData.refetch()
            } catch (error) {
                console.error(error)
            }
        }
    }, [isAccountLoading])

    useEffect(() => {
        if (refreshAccounts) {
            try {
                accountsData.refetch()
                taxData.refetch()
                dispatch(setRefreshAccounts(false))
            } catch (error) {
                console.error(error)
            }
        }
    }, [refreshAccounts])

    useEffect(() => {
        if (refetchSyncCount) {
            try {
                syncCounts?.refetch()
                dispatch(setRefetchSyncCount(false))
            } catch (error) {
                console.error(error)
            }
        }
    }, [refetchSyncCount])

    useEffect(() => {
        if (currentComponent === "service category mapping" && !amIVisible("service by categories")) {
            dispatch(setCurrentComponent("service product mapping"))
        }
    }, [currentComponent, dispatch])

    /* handle isCompanyAuthorize response */
    useEffect(() => {

        const { isSuccess, data, isError, error } = isCompanyAuthorizeResponse;

        if (isSuccess && companyName === "") {
            setCompanyName(data?.companyName)
            setJeAsCategory(data?.JeAsInvoice)
            dispatch(setShowLayAway(data?.isLayAway ?? false))
            dispatch(setIsTaxAgency(data?.taxAgency ?? false))
            setConnected(true)
        }

        // TODO: check other response codes
        if (isError && !connectionMode) {
            if (error.status === 404) {
                navigate("../user-onboard/")
            } else if (error.status === 430) {
                dispatch(setIsReconnecting(1))
                navigate("../user-onboard/")
            }
        }

    }, [isCompanyAuthorizeResponse])

    const getContext = (props) => {
        switch (currentComponent) {
            case "sync history":
                return <SyncLogs />
            case "po sync history":
                return <SyncLogs isTypePo />
            case "payment mapping":
                return <IndividualPaymentMapping {...props} />
            case "discount mapping":
                return <IndividualDiscountMapping {...props} />
            case "sales product mapping":
                return <IndividualProductMapping {...props} />
            case "sales product level mapping":
                return <IndividualProductIDsMapping {...props} />
            case "sales category mapping":
                return <IndividualCategoriesMapping {...props} />
            case "service product mapping":
                return <IndividualServiceProductMapping {...props} />
            case "service category mapping":
                return <IndividualServiceCategoryMapping {...props} />
            case "po product mapping":
                return <IndividualPoProductMapping {...props} />
            case "po product level mapping":
                return <IndividualPoProductLevelMapping {...props} />
            case "po category mapping":
                return <IndividualPoCategoriesMapping {...props} />
            default:
                return <></>
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0)

        if (currentComponent === "dash") {
            dispatch(resetSyncPage())
        }

    }, [currentComponent])

    return (
        <>
            <SessionTimeoutError navigate={navigate} />
            <Formik
                initialValues={configData || initialValues}
                validationSchema={getValidationSchema(t)}
                enableReinitialize
            >
                {formik =>
                    <>
                        <DashboardWrapper
                            formik={formik}
                        >
                            {
                                currentComponent === "dash" ?
                                    <>
                                        <PageLayout
                                            showDisconnected={false}
                                            path={location.pathname}
                                            navigate={navigate}
                                            formik={formik}
                                            refetchConfig={configurationResponse?.refetch}
                                            title={isMultiLocation && currentLocation?.name}
                                            description={isMultiLocation && t('locationMappingDesc')}
                                            showBack={isMultiLocation}
                                        >
                                            <InfoDashboard formik={formik} />
                                            <Divider />
                                            {formik.values.postingMethod &&
                                                <>
                                                    <MapAccounts
                                                        formik={formik}
                                                        {...routeProps}
                                                    />
                                                    {amIVisible("po cogs") &&
                                                        <>
                                                            <Divider />
                                                            <CogsInventorySection
                                                                formik={formik}
                                                                {...routeProps} />
                                                        </>
                                                    }
                                                    {
                                                        <>
                                                            <Divider />
                                                            <OptionsSection
                                                                formik={formik}
                                                                {...routeProps}
                                                            />
                                                        </>
                                                    }
                                                </>
                                            }
                                        </PageLayout>
                                    </>
                                    :
                                    <>
                                        {getContext({ formik, ...routeProps })}
                                    </>
                            }
                        </DashboardWrapper>
                    </>
                }
            </Formik>
            <Logout navigate={navigate} />
        </>
    )
};

const DashboardWrapper = ({
    formik,
    children,
}) => {
    return <Form>{children}</Form>
}